import styles from "./LoaderBlock.module.scss";

export const LoaderBlock = () => {
  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.loader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
